import { initISWSideEffect } from "../../shared/components/isw-side-effects/create-isw-helpers";
import { OndernemingModalType } from "../infra/inkomen-en-fiscus-schema";
import { determineGemiddeldInkomensVerleden } from "../infra/shared-components/determine-inkomensverleden-side-effects";

export const ondernemingModalSideEffects = initISWSideEffect<OndernemingModalType>(bag => {
  determineGemiddeldInkomensVerleden(bag.subset.inkomensverleden.create());
});
